import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p className="loading-text">
        Analyzing job posting and customizing your resume...
      </p>
      <p className="loading-text" style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.5rem' }}>
        This may take 10-30 seconds
      </p>
    </div>
  );
};

export default LoadingSpinner;